export const unwrapRows = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.rows)) return response.rows;
  if (Array.isArray(response?.data?.rows)) return response.data.rows;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  return [];
};

export const unwrapMeta = (response, fallbackLength = 0) => {
  const meta = response?.meta || response?.data?.meta || {};
  return {
    page: Number(meta.page) || 1,
    limit: Number(meta.limit) || fallbackLength || 10,
    total: Number(meta.total) || fallbackLength,
    pages: Number(meta.pages) || Math.max(1, Math.ceil(fallbackLength / 10)),
  };
};

export const unwrapDetail = (response) => response?.data || response || null;

export const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const personName = (value) =>
  value?.name ||
  value?.fullName ||
  value?.employeeName ||
  value?.email ||
  (typeof value === "string" ? value : "-");

export const recordId = (value) => value?._id || value?.id || value?.code;
